<template>
  <div class="container">
    <h2>Marcas de autos</h2>
    <div class="row">
      <!--cards-->
      <b-card-group
        deck
        v-for="(marca, index) in traerdatamarcas"
        :key="index"
        class="col-12 col-sm-12 col-md-6 col-lg-4 col-xl-4"
      >
        <b-card :title="marca.nombremarca">
          <b-card-text>
            <img :src="marca.url" :alt="marca.nombremarca" />
          </b-card-text>
        </b-card>
      </b-card-group>
    </div>
    <!--/cards-->
  </div>
</template>

<script>
export default {
  name: "Marcas",
  data() {
    return {};
  },
  computed: {
    traerdatamarcas() {
      return this.$store.getters.enviardatamarcas;
    },
  },
};
</script>

<style></style>
